import styled from 'styled-components/macro';
import { highlight } from './colors';

export const HighlightText = styled.div`
  color: ${highlight};
  grid-area: text;
  font-size: 11px;
`;
